<template>
    <div class="container">
        <el-form size="mini" :inline="true" label-position="left" :model="queryForm" ref="queryForm">
            <el-form-item label="店铺名称" prop="shopId" v-if="shops.length > 0">
                <el-select
                    v-model="queryForm.shopId"
                    filterable
                    remote
                    clearable
                    :remote-method="remoteShopMethod"
                    placeholder="请输入店铺">
                    <el-option
                        v-for="item in shopList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="交易时间:" prop="date">
                <el-date-picker size="small"
                                style="width: 250px;"
                                v-model="queryForm.dateRange"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                placeholder="请选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="交易类型:" prop="type">
                <el-select v-model="queryForm.type" placeholder="请选择">
                    <el-option value="0" label="全部"></el-option>
                    <el-option value="1" label="校园卡"></el-option>
                    <el-option value="2" label="非校园卡"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="mini" type="primary" @click="fetchData">查询</el-button>
                <el-button size="mini" @click="resetForm('queryForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-row class="pb10">
            <el-button type="primary" size="mini" @click="printPDF">打印</el-button>
        </el-row>
        <el-card class="box-card mb20" style="background-color: #eaf5fc">
            <el-row>
                <el-col :span="4">
                    <p>销售订单总计</p>
                    <p class="red mt10">{{summary.orderCount}}单</p>
                </el-col>
                <el-col :span="4">
                    <p>销售订单金额总计</p>
                    <p class="red mt10">{{summary.orderAmount}}元</p>
                </el-col>
                <el-col :span="4">
                    <p>退款订单总计</p>
                    <p class="red mt10">{{summary.refundCount}}单</p>
                </el-col>
                <el-col :span="3">
                    <p>退款金额总计</p>
                    <p class="red mt10">{{summary.refundAmount}}元</p>
                </el-col>
                <el-col :span="3">
                    <p>商户结算款总计</p>
                    <p class="red mt10">{{summary.sealAmount}}元</p>
                </el-col>
                <el-col :span="3">
                    <p>订单营业款总计</p>
                    <p class="red mt10">{{summary.incomeAmount}}元</p>
                </el-col>
                <el-col :span="3">
                    <p>搭伙费总计</p>
                    <p class="red mt10">{{summary.extraAmount}}元</p>
                </el-col>
            </el-row>
        </el-card>
        <export-excel style="margin-right: 20px;" class="fl" :params="exportParams" :action="$apiUrl.checkBillTotalSchool" :target="'oc'" :field="field" :filename="filename" :fieldname="fieldName"></export-excel>
        <el-popover
            style="float: left;margin-bottom: 20px;"
            placement="right"
            width="560"
            trigger="click">
            <div>
                <p class="mb20 mt10">1、销售订单金额-退款订单金额=订单营业款=商户结算款+服务费（佣金）+加价配送费+搭伙费</p>
                <p class="mb20">2、日结非校园卡结算金额=商户结算款+搭伙费（公司付学校）</p>
                <p class="mb20">3、月结校园卡结算金额=服务费（佣金）+加价配送费（学校付公司）</p>
            </div>
            <el-button size="mini" type="primary" slot="reference">财务公式</el-button>
        </el-popover>
        <el-table
            v-loading="loading"
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
                prop="date"
                label="时间"
                width="140"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="schoolName"
                label="学校名称"
                width="150"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="shopName"
                label="店铺名称"
                width="120"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="type"
                label="交易类型"
                width="80"
                :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span v-if="scope.row.type==1">校园卡</span>
                    <span v-else-if="scope.row.type==2">非校园卡</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="orderNum"
                label="销售订单笔数"
                width="100"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="orderAmount"
                label="营业金额（含退款）"
                width="100"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="refundOrderNum"
                label="退款订单笔数"
                width="100"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="refundOrderAmount"
                label="退款订单营业款"
                width="100"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="incomeAmount"
                width="100"
                label="营业金额"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="commercialAmount"
                width="100"
                label="商户结算款"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="settleAmount"
                width="100"
                label="商户结算款（含退款）"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="refundSettleAmount"
                width="100"
                label="退款订单结算款"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="commission"
                label="服务费"
                width="80"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="alyIncome"
                label="加价配送费"
                width="100"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="cutDeliveryFee"
                label="配送费扣除"
                width="100">
                <template slot-scope="scope">
                    <span>{{scope.row.cutDeliveryFee?scope.row.cutDeliveryFee:'—'}}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="extraAmount"
                label="搭伙费"
                width="">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
// import { getSchoolAndShop } from '~/mixins/getSchoolAndShop1'
import moment from 'moment'
import exportExcel from '~/components/exportExcel2.vue'
export default {
    components: {exportExcel},
    name: "schoolTotalBill",
    data() {
        return {
            queryFormLabelWidth: '100px',//自定义查询表单label宽度
            queryForm: {//查询表单数据
                schoolId: localStorage.getItem('schoolId'),
                shopId: '',
                dateRange: [],
                commercialId: '',
                type: '',
                is_authneed: true,
                for_report: true
            },
            // schools: JSON.parse(localStorage.getItem('manager_school')),
            // schoolList: [],
            tableData: [],//表格数据
            loading: false,//表格是否显示加载效果
            commercialList: [],
            //导出
            exportParams: {},
            filename: '校企对账汇总表',
            fieldName: ['时间','学校名称','店铺名称','交易类型','销售订单笔数','营业金额（含退款）','退款订单笔数','退款订单营业款','营业金额','商户结算款（含退款）','退款订单结算款','商户结算款','服务费（佣金）','加价配送费','配送费扣除','搭伙费'],
            field: ['date','schoolName','shopName','typeStr','orderNum','orderAmount','refundOrderNum','refundOrderAmount','incomeAmount','settleAmount','refundSettleAmount','commercialAmount','commission','alyIncome','cutDeliveryFee','extraAmount'],
            shops: JSON.parse(localStorage.getItem('shops')),
            shopList: [],
            summary: {}
        }
    },
    computed: {
        operation: function(){
            return this.$store.getters.operation
        }
    },
    created(){
        //默认显示最近一周
        var day = new Date();
        // day.setTime(day.getTime()-7*24*60*60*1000);
        this.queryForm.dateRange = [new Date(),new Date()];
        this.fetchData();
    },
    methods: {
        fetchData() {
            let params = {...this.queryForm};
            if(params.dateRange && params.dateRange.length > 0){
                params.startDate = moment(params.dateRange[0]).format('YYYYMMDD');
                params.endDate = moment(params.dateRange[1]).format('YYYYMMDD');
                delete params.dateRange;
            }else{
                this.$message.warning('请选择预计打款时间');
                return;
            }
            this.exportParams = {...params};
            this.loading = true;
            this.$apiJava.post(this.$apiUrl.checkBillTotalSchool,params,(res)=>{
                this.loading = false;
                this.tableData = res.data.list || [];
            },(res)=>{
                this.$message.warning(res.msg);
                this.loading = false;
                this.tableData = [];
            },'oc')
            this.$apiJava.post(this.$apiUrl.reconciliationBillSummary,params,(res)=>{
                this.summary = res.data;
            },(res)=>{
                this.$message.warning(res.msg);
            },'oc')
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            var day = new Date();
            day.setTime(day.getTime()-7*24*60*60*1000);
            this.queryForm.dateRange = [day,new Date()];
        },
        remoteShopMethod(query){
            if (query !== '') {
                this.shopList = [];
                var arr = [];
                let len = this.shops.length;
                var reg = new RegExp(query);
                for(var i=0;i<len;i++){
                    //如果字符串中不包含目标字符会返回-1
                    if(this.shops[i].name.match(reg)){
                        this.shopList.push(this.shops[i]);
                    }
                }
            } else {
                this.shopList = [];
            }
        },
        printPDF() {
            let hostStr = window.location.host;
            let host = hostStr.replace('e','oc');
            let url = location.protocol +'//'+ host + '/' + this.$apiUrl.schoolCompanyExportPDF + '?export=2&startDate=' + moment(this.queryForm.dateRange[0]).format('YYYYMMDD') + '&endDate=' + moment(this.queryForm.dateRange[1]).format('YYYYMMDD') + '&schoolId=' + this.queryForm.schoolId + '&shopId=' + this.queryForm.shopId + '&type=' + this.queryForm.type + '&isShowSensitiveData=1';
            window.open(url);
        }

    }
}
</script>

<style lang="scss"  scoped>
.el-card{
    border: none;
    box-shadow: none;
}
</style>


// WEBPACK FOOTER //
// schoolTotalBill.vue?2a23ae63